import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as licenseActions from 'modules/license';

import { Button, Icon } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';

import * as templateLib from 'libs/templateLib';
import * as templateActions from 'modules/template';

import { LicenseDelete } from 'components';

class CtLicenseDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      deleteModal: false
    };
  }

  mountDeleteModal = () => {
    const { deleteModal } = this.state;

    if (deleteModal) {
      // 열려진 경우로 닫는다.
      this.setState({ deleteModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ deleteModal: true });
    }
  };

  removeLicense = async () => {
    this.setState({ onProgress: true });

    const { licenseInfo: { licenseNo } } = this.props;

    const params = {};
    let isOk = true;
    if (licenseNo) {
      params.licenseNo = licenseNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { LicenseActions } = this.props;
        await LicenseActions.deleteLicense(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('removeLicense isOk fail!');
    }

    this.mountDeleteModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, deleteModal } = this.state;
    const { inTableMenu, isAuth, licenseInfo } = this.props;
    const { mountDeleteModal, removeLicense } = this;

    return (
      <div>
        {inTableMenu && isAuth === 2 ? (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'CtLicenseDelete_1', defaultMessage: '라이센스 삭제' }))}
            placement="bottom">
            <Icon color="grey" className="icon-remove" name="remove circle" link onClick={mountDeleteModal} />
          </Tooltip>
        ) : (
          <Button
            className="bt-style-gleam license-button-gray"
            size="small"
            content={defineMessages(formatMessage({ id: 'CtLicenseDelete_2', defaultMessage: '신청 취소' }))}
            onClick={mountDeleteModal}
          />
        )}
        {deleteModal && (
          <LicenseDelete
            deleting={onProgress}
            licenseInfo={licenseInfo}
            isAuth={isAuth}
            inTableMenu={inTableMenu}
            handleOnToggleDeleteModal={mountDeleteModal}
            removeLicense={removeLicense}
          />
        )}
      </div>
    );
  }
}

CtLicenseDelete.propTypes = {
  licenseInfo: PropTypes.object
};
CtLicenseDelete.defaultProps = {
  licenseInfo: {}
};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  LicenseActions: bindActionCreators(licenseActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtLicenseDelete));



// WEBPACK FOOTER //
// ./src/script/containers/license/CtLicenseDelete.js